<form [formGroup]="form" (ngSubmit)="onFormSubmit()">
  <nb-card class="form" [class.form--picker]="!data">
    <nb-card-header
      ><h4>
        {{
          (data ? "dialogs.tutor.titleEdit" : "dialogs.tutor.titleCreate")
            | translate
        }}
      </h4></nb-card-header
    >
    <nb-card-body>
      <!-- ===================================================================
           EDIT — unverändert: Name, Beschreibung, Template (gesperrt).
           Der mehrstufige Picker ist nur beim Anlegen sinnvoll — beim
           Bearbeiten steht das Template schon fest.
           =================================================================== -->
      <ng-container *ngIf="data">
        <div class="form-group row">
          <label for="title" class="label col-sm-3 col-form-label">
            {{ "input.name.label" | translate }}
          </label>
          <div class="col-sm-9">
            <input
              type="text"
              nbInput
              fullWidth
              id="name"
              placeholder="{{ 'input.name.placeholderTutor' | translate }}"
              formControlName="name"
              required
              [status]="showInputError('name') ? 'danger' : 'basic'"
            />
          </div>
        </div>

        <div class="form-group row">
          <label for="title" class="label col-sm-3 col-form-label">
            {{ "input.description.label" | translate }}
          </label>
          <div class="col-sm-9">
            <input
              type="text"
              nbInput
              fullWidth
              id="description"
              placeholder="{{ 'input.description.placeholderTutor' | translate }}"
              formControlName="description"
              [status]="showInputError('description') ? 'danger' : 'basic'"
            />
          </div>
        </div>

        <div class="form-group row">
          <label for="title" class="label col-sm-3 col-form-label">{{
            "input.tutorTemplate.label" | translate
          }}</label>
          <div class="col-sm-9">
            <nb-form-field>
              <nb-icon nbPrefix icon="orbi" pack="al"></nb-icon>
              <nb-select
                formControlName="template_id"
                aria-required="true"
                [status]="showInputError('template_id') ? 'danger' : 'basic'"
                placeholder="KI-Agent template wählen"
              >
                <nb-option
                  *ngFor="let t of creatableTemplates$ | async"
                  [value]="t.id"
                >
                  {{ "enums.assistantTemplate." + t.name | translate }}</nb-option
                >
              </nb-select>
            </nb-form-field>
            <nb-icon
              icon="question-mark-circle-outline"
              [nbPopover]="getTemplateIdDescription() | translate"
              nbPopoverTrigger="hover"
            ></nb-icon>
          </div>
        </div>
      </ng-container>

      <!-- ===================================================================
           CREATE — dreistufiger Picker: Vorlage → Tutor-Variante → Bestätigung
           mit Name/Beschreibung. Siehe design.md für die Begründung, warum
           Alpha Tutor als einzige Kachel eine zweite Ebene öffnet.
           =================================================================== -->
      <ng-container *ngIf="!data">

        <!-- ============ EBENE 1: Vorlage ============ -->
        <div class="stage" *ngIf="stage === 'templates'">
          <h5 class="section-label">{{ "dialogs.tutor.pick.sectionLabel" | translate }}</h5>
          <p class="section-hint">{{ "dialogs.tutor.pick.sectionHint" | translate }}</p>

          <div class="templates" role="radiogroup" [attr.aria-label]="'dialogs.tutor.pick.sectionLabel' | translate">
            <div
              *ngFor="let t of stage1Cards"
              class="template"
              [alAnchor]="'agenttemplate.' + t.name"
              [class.is-selected]="isSelected(t)"
              [class.is-open]="isExpanded(t.id)"
              role="radio"
              [attr.aria-checked]="isSelected(t)"
              [attr.tabindex]="isSelected(t) ? 0 : -1"
              (click)="selectStage1(t)"
              (keydown)="onTemplateCardKeydown($event, t)"
            >
              <app-orbi-lab
                [type]="orbTypeFor(t.name)"
                [size]="96"
                [script]="orbScriptFor(t.name)"
              ></app-orbi-lab>

              <h6 class="template__name">{{ "enums.assistantTemplate." + t.name | translate }}</h6>
              <p class="template__pitch">{{ "dialogs.tutor.pick.templates." + t.name + ".pitch" | translate }}</p>

              <button
                type="button"
                class="more-toggle"
                [attr.aria-expanded]="isExpanded(t.id)"
                (click)="toggleDetails(t.id, $event)"
              >
                <span>{{ (isExpanded(t.id) ? "dialogs.tutor.pick.lessInfo" : "dialogs.tutor.pick.moreInfo") | translate }}</span>
                <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                  <path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
              <div class="template__details">
                <div><p>{{ "dialogs.tutor.pick.templates." + t.name + ".details" | translate }}</p></div>
              </div>

              <div class="features">
                <span *ngFor="let b of badgesFor(t.name)" class="pill" [ngClass]="'pill--' + b.cls">
                  {{ "dialogs.tutor.pick.badges." + b.key | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- ============ EBENE 2: Tutor-Variante ============ -->
        <div class="stage" *ngIf="stage === 'variant'">
          <div class="stage-head">
            <div>
              <h5 class="section-label">{{ "dialogs.tutor.pick.variantTitle" | translate }}</h5>
              <p class="section-hint">{{ "dialogs.tutor.pick.variantHint" | translate }}</p>
            </div>
            <button type="button" class="back-link" (click)="backToTemplates()">
              <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M10 12L6 8l4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              {{ "dialogs.tutor.pick.otherTemplate" | translate }}
            </button>
          </div>

          <div class="variants" role="radiogroup" [attr.aria-label]="'dialogs.tutor.pick.variantTitle' | translate">
            <div
              *ngFor="let v of variantCards; trackBy: trackVariant"
              class="template variant"
              [alAnchor]="'agentvariant.' + v.template.name"
              [class.variant--starter]="v.level === 'starter'"
              [class.variant--pro]="v.level === 'pro'"
              [class.is-selected]="isSelected(v.template)"
              role="radio"
              [attr.aria-checked]="isSelected(v.template)"
              [attr.tabindex]="isSelected(v.template) ? 0 : -1"
              (click)="selectVariant(v.template)"
              (keydown)="onVariantCardKeydown($event, v.template)"
            >
              <app-orbi-lab
                [type]="orbTypeFor(v.template.name)"
                [size]="96"
                [script]="orbScriptFor(v.template.name)"
              ></app-orbi-lab>

              <span class="variant__level">
                {{ "dialogs.tutor.pick." + (v.level === 'starter' ? 'starterLevel' : 'proLevel') | translate }}
              </span>
              <h6 class="template__name">{{ "enums.assistantTemplate." + v.template.name | translate }}</h6>
              <p class="template__pitch">{{ "dialogs.tutor.pick.variants." + v.template.name + ".pitch" | translate }}</p>

              <div class="features">
                <span *ngFor="let b of badgesFor(v.template.name)" class="pill" [ngClass]="'pill--' + b.cls">
                  {{ "dialogs.tutor.pick.badges." + b.key | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- ============ EBENE 3: Bestätigung — der Orb freut sich ============ -->
        <div class="stage" *ngIf="stage === 'confirm'">
          <div class="stage-head">
            <div>
              <h5 class="section-label">{{ "dialogs.tutor.pick.confirmTitle" | translate }}</h5>
              <p class="section-hint">{{ "dialogs.tutor.pick.confirmHint" | translate }}</p>
            </div>
            <button type="button" class="back-link" (click)="backFromConfirm()">
              <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M10 12L6 8l4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              {{ "dialogs.tutor.pick.otherTemplate" | translate }}
            </button>
          </div>

          <div class="confirm">
            <app-agent-orb
              class="confirm__orb"
              [type]="confirmOrbType"
              [size]="132"
              mood="happy"
              [label]="confirmTemplate ? ('enums.assistantTemplate.' + confirmTemplate.name | translate) : ''"
            ></app-agent-orb>
            <h6 class="confirm__name" *ngIf="confirmTemplate">
              {{ "enums.assistantTemplate." + confirmTemplate.name | translate }}
            </h6>
            <p class="confirm__line">{{ "dialogs.tutor.pick.confirmLine" | translate }}</p>

            <div class="confirm-fields">
              <label class="field">
                <span class="field__label">{{ "dialogs.tutor.pick.nameLabel" | translate }}</span>
                <input
                  #nameInput
                  type="text"
                  alAnchor="agents.dialog-name"
                  class="field__input"
                  formControlName="name"
                  placeholder="{{ 'dialogs.tutor.pick.namePlaceholder' | translate }}"
                  autocomplete="off"
                />
              </label>

              <label class="field">
                <span class="field__label">
                  {{ "dialogs.tutor.pick.descriptionLabel" | translate }}
                  <span class="field__label-hint">{{ "dialogs.tutor.pick.descriptionHint" | translate }}</span>
                </span>
                <textarea
                  class="field__input field__textarea"
                  formControlName="description"
                  placeholder="{{ 'dialogs.tutor.pick.descriptionPlaceholder' | translate }}"
                  rows="2"
                ></textarea>
              </label>
            </div>
          </div>
        </div>

      </ng-container>
    </nb-card-body>
    <nb-card-footer>
      <button
        type="button"
        nbButton
        status="danger"
        outline
        (click)="dialogRef.close()"
      >
        {{ "buttons.cancel" | translate }}
      </button>

      <!-- EDIT: unveränderter Submit-Button -->
      <button
        *ngIf="data"
        type="submit"
        nbButton
        status="primary"
        [nbSpinner]="tutorService.loading$.value"
        nbSpinnerStatus="control"
      >
        {{ "buttons.create" | translate }}
      </button>

      <!-- CREATE: ein Button für alle drei Ebenen — Text und Aktion
           richten sich nach `stage`, damit "Weiter" und "Erstellen" nie
           auseinanderlaufen können. -->
      <button
        *ngIf="!data"
        type="button"
        nbButton
        status="primary"
        alAnchor="agents.dialog-next"
        [disabled]="stage === 'confirm' && !canCreate"
        [nbSpinner]="tutorService.loading$.value"
        nbSpinnerStatus="control"
        (click)="goNext()"
      >
        {{ (stage === 'confirm' ? "dialogs.tutor.pick.create" : "dialogs.tutor.pick.next") | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
